import ConfirmAccount from './confirm-account';

export default ConfirmAccount;